import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-74fe0e7c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "context-menu-container"
};
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default {
  __name: 'ContextMenu',
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const onRefreshClick = () => {
      router.go(0);
    };
    const store = useStore();
    const onCloseRightClick = () => {
      store.commit('app/removeTagsView', {
        type: 'right',
        index: props.index
      });
    };
    const onCloseOtherClick = () => {
      store.commit('app/removeTagsView', {
        type: 'other',
        index: props.index
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("ul", _hoisted_1, [_createElementVNode("li", {
        onClick: onRefreshClick
      }, "刷新"), _createElementVNode("li", {
        onClick: onCloseRightClick
      }, "关闭右侧"), _createElementVNode("li", {
        onClick: onCloseOtherClick
      }, "关闭其他")]);
    };
  }
};